import { DeviceClient } from '@frontend/device/api';
import { Device, DeviceType } from '@frontend/device/types';
import { useEffect, useState } from 'react';

import { useScreen } from '../useScreen';

interface ViewProps {
    isLoading?: boolean;
    gates: Device[];
}

const useManageGates = (): ViewProps => {
    const { navigationState } = useScreen();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [gates, setGates] = useState<Device[]>([]);

    useEffect(() => {
        const fetchGates = async () => {
            const response = await DeviceClient.fetchDevices({
                account_id: navigationState.iot?.account_id,
                type: DeviceType.DOOR,
                sort_field: 'name',
                sort_direction: 'asc',
                size: '100'
            });
            setGates(response.results);
        };
        fetchGates().finally(() => setIsLoading(false));
    }, []);

    return { isLoading, gates };
};

export default useManageGates;
